<template>
  <div>
    <h2>Categorias</h2>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="data"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" persistent max-width="940">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  color="#0dc4b8"
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Nova Categoria
                </v-btn>
              </template>
              <v-card>
                <v-card-title>{{ titleDialog }}</v-card-title>
                <v-divider></v-divider>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        label="Nome da categoria"
                        required
                        hide-details="auto"
                        v-model="selectedItem.category"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-textarea
                        v-model="selectedItem.description"
                        label="Descrição"
                        required
                        hide-details="auto"
                        :counter="250"
                        :rules="[
                          (v) =>
                            (v || '').length <= 250 ||
                            'A descrição deve ter 250 caracteres ou menos',
                        ]"
                      ></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-file-input
                        v-model="selectedItem.photo"
                        hide-details="auto"
                        label="Imagem da categoria"
                        prepend-icon="mdi-camera"
                        accept="image/*"
                        show-size
                        small-chips
                        @change="selectNewPhoto"
                      ></v-file-input>
                    </v-col>
                  </v-row>
                </v-container>
                <br />
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#0dc4b8" text @click="closeDialog">
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="#0dc4b8"
                    text
                    type="submit"
                    @click="saveCategory"
                    :disabled="
                      isLoading ||
                      ['Administrador', 'Cliente'].includes(selectedItem.name)
                    "
                    :loading="isLoading"
                  >
                    {{ textBtnDialog }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="940">
              <v-card>
                <v-card-title class="headline center"
                  >Deseja realmente excluir {{ selectedItem.id }} -
                  {{ selectedItem.category }} ?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#0dc4b8" text @click="closeDialogDelete"
                    >Cancelar</v-btn
                  >
                  <v-btn
                    color="#0dc4b8"
                    text
                    @click="deleteItemConfirm"
                    :disabled="
                      isLoading ||
                      ['Administrador', 'Cliente'].includes(selectedItem.name)
                    "
                    :loading="isLoading"
                    >OK</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-title>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>
        <!-- <template v-slot:no-data>
          <v-btn color="primary" @click="editItem(item)"> Reset </v-btn>
        </template> -->
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import Api from "../../services/api.service";
import { mapMutations } from "vuex";

export default {
  name: "Categories",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Api,
  },
  data: () => ({
    data: [],
    dialog: false,
    dialogDelete: false,
    titleDialog: "Nova Categoria",
    textBtnDialog: "Salvar",
    from: 0,
    search: "",
    newPhoto: 0,
    editCategory: 0,
    idDeleteCategory: null,
    idEditCategory: null,
    headers: [
      { text: "ID", value: "id" },
      { text: "Nome da categoria", value: "category" },
      { text: "Ação", value: "actions" },
    ],
    isLoading: false,
    page: 1,
    perPage: 10,
    searchFilter: {
      query: null,
    },
    selectedIndex: -1,
    selectedItem: {
      category: null,
      id: 0,
      description: null,
      photo: null,
    },
    to: 0,
    total: 0,
    totalPages: 0,
  }),
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapMutations(["showSnackbar"]),

    openDialog() {
      this.dialog = true;
    },

    openDialogDelete() {
      this.dialogDelete = true;
    },

    closeDialogDelete() {
      this.dialogDelete = false;
      this.selectedItem = {
        category: null,
        id: 0,
      };
      this.selectedIndex = -1;
    },

    closeDialog() {
      this.dialog = false;
      this.titleDialog = "Nova Categoria";
      this.textBtnDialog = "Salvar";
      this.selectedItem = {
        category: null,
        id: 0,
      };
      this.selectedIndex = -1;
      this.editCategory = 0;
      this.idDeleteCategory = null;
      this.isLoading = false;
      this.newPhoto = 0;
    },

    editItem(item) {
      this.selectedIndex = this.data.indexOf(item);
      this.selectedItem = Object.assign({}, item);
      this.idEditCategory = item.id;
      this.titleDialog = "Editar Categoria";
      this.textBtnDialog = "Atualizar";
      this.selectedItem = item;
      this.editCategory = 1;
      this.openDialog();
    },

    deleteItem(item) {
      this.selectedIndex = this.data.indexOf(item);
      this.selectedItem = Object.assign({}, item);
      this.idDeleteCategory = item.id;
      this.isLoading = false;
      this.openDialogDelete();
    },

    deleteItemConfirm() {
      this.isLoading = true;
      Api.delete(`categories/${this.idDeleteCategory}`)
        .then(() => {
          this.loadData();
          this.showSnackbar({
            text: "Categoria deletada com sucesso!",
            color: "success",
          });
          this.closeDialogDelete();
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.showSnackbar({
            text: "Ops! Ocorreu um erro, tente novamente.",
            color: "error",
          });
        });
    },

    loadData() {
      this.isLoading = true;
      Api.get("categories")
        .then((res) => {
         
          var arrayCategory = [];

          res.data[0].map((item) => {
            arrayCategory.push({
              id: item.id,
              category: item.name,
              description: item.description,
              photo: new File(
                ["https://filesgpx.s3.us-east-2.amazonaws.com/" + item.path],
                item.name_file,
                {
                  type: item.mime_type,
                }
              ),
            });
          });

          this.data = arrayCategory;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },

    selectNewPhoto() {
      this.newPhoto = 1;
    },

    saveCategory() {
      if (!this.selectedItem.category) {
        this.showSnackbar({
          text: "Preencha o nome da categoria para continuar.",
          color: "error",
        });
        return false;
      }

      if (!this.selectedItem.description) {
        this.showSnackbar({
          text: "Preencha a descrição da categoria para continuar.",
          color: "error",
        });
        return false;
      }

      if (this.selectedItem.description.length > 250) {
        this.showSnackbar({
          text: "A descrição deve ter 250 caracteres ou menos.",
          color: "error",
        });
        return false;
      }

      if (!this.selectedItem.photo) {
        this.showSnackbar({
          text: "Preencha a foto de capa da categoria para continuar.",
          color: "error",
        });
        return false;
      }

      if (this.editCategory === 0) {
        this.isLoading = true;

        let data = new FormData();

        data.append("name", this.selectedItem.category);
        data.append("description", this.selectedItem.description);
        data.append("photo", this.selectedItem.photo);

        Api.post("categories", data, {
          header: {
            "Content-Type": "multipart/form-data",
          },
        })
          .then(() => {
            this.loadData();
            this.showSnackbar({
              text: "Categoria cadastrada com sucesso!",
              color: "success",
            });
            this.closeDialog();
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
            this.showSnackbar({
              ext: "Ops! Ocorreu um erro, tente novamente.",
              color: "error",
            });
          });
      } else {
        this.isLoading = true;

        let data = new FormData();

        data.append("name", this.selectedItem.category);
        data.append("description", this.selectedItem.description);
        data.append("photo", this.selectedItem.photo);
        data.append("newPhoto", this.newPhoto);

        Api.post(`categories/${this.idEditCategory}`, data, {
          header: {
            "Content-Type": "multipart/form-data",
          },
        })
          .then(() => {
            this.loadData();
            this.showSnackbar({
              text: "Categoria atualizada com sucesso!",
              color: "success",
            });
            this.closeDialog();
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
            this.showSnackbar({
              ext: "Ops! Ocorreu um erro, tente novamente.",
              color: "error",
            });
          });
      }
    },
  },
};
</script>
